import {
  Toaster as SonnerSnackbar,
  type ToasterProps,
  toast as sonnerToast,
} from "sonner";

import { cn } from "@/lib/utils";

const Snackbar = ({ ...props }: ToasterProps) => {
  return (
    <SonnerSnackbar
      theme="light"
      className={cn("wl-snackbar", props.className)}
      closeButton={true}
      duration={Infinity}
      id="snackbar-instance"
      position="bottom-right"
      toastOptions={{
        classNames: {
          info: "wl-toast-info",
          warning: "wl-toast-warning",
          success: "wl-toast-success",
          error: "wl-toast-error",
        },
      }}
      {...props}
    />
  );
};

export const snackbar = {
  show: (title: string, options?: any) => {
    // Dismiss existing snackbars before showing new one
    sonnerToast.dismiss();
    return sonnerToast(title, {
      ...options,
      toasterId: "snackbar-instance",
      id: `snackbar-${Date.now()}-${Math.random()}`,
    });
  },
  success: (title: string, options?: any) => {
    // Dismiss existing snackbars before showing new one
    sonnerToast.dismiss();
    return sonnerToast.success(title, {
      ...options,
      toasterId: "snackbar-instance",
      id: `snackbar-success-${Date.now()}-${Math.random()}`,
    });
  },
  error: (title: string, options?: any) => {
    // Dismiss existing snackbars before showing new one
    sonnerToast.dismiss();
    return sonnerToast.error(title, {
      ...options,
      toasterId: "snackbar-instance",
      id: `snackbar-error-${Date.now()}-${Math.random()}`,
    });
  },
  warning: (title: string, options?: any) => {
    // Dismiss existing snackbars before showing new one
    sonnerToast.dismiss();
    return sonnerToast.warning(title, {
      ...options,
      toasterId: "snackbar-instance",
      id: `snackbar-warning-${Date.now()}-${Math.random()}`,
    });
  },
  info: (title: string, options?: any) => {
    // Dismiss existing snackbars before showing new one
    sonnerToast.dismiss();
    return sonnerToast.info(title, {
      ...options,
      toasterId: "snackbar-instance",
      id: `snackbar-info-${Date.now()}-${Math.random()}`,
    });
  },
  promise: (promise: Promise<any>, options: any) => {
    // Dismiss existing snackbars before showing new one
    sonnerToast.dismiss();
    return sonnerToast.promise(promise, {
      ...options,
      toasterId: "snackbar-instance",
      id: `snackbar-promise-${Date.now()}-${Math.random()}`,
    });
  },
  dismiss: (id?: string | number) => {
    return sonnerToast.dismiss(id);
  },
  dismissAll: () => {
    return sonnerToast.dismiss();
  },
};

export { Snackbar };
